import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './CanvasExample.css';

import equal from 'deep-equal';
import {clamp} from '@/util/bounds.js';

const actions = {};



const getIndexForZoom = function(src, mix, effectiveZ) {
    //this.props.src.length-1
    if (typeof src == 'string' || mix == undefined) {
        return -1;
    }

    // console.log(z);

    const mixLen = mix ? mix.length : 1;
    for (var mixI = 0; mixI < mixLen; mixI++) {
        // console.log('MIX!', mix);
        let minZoom = mix[mixI].minZoom;
        let maxZoom = mix[mixI].maxZoom;
        if (minZoom <= effectiveZ && maxZoom >= effectiveZ) {
            // console.log('MIX', mixI)
            return mixI;
        }
    }
}



/** 
 * Draw a simple shape
 * (this text is automatically indluded 
 * from the .js component definition JSDOC header)
 */
class CanvasExample extends Component {
    constructor(props) {
        super(props);

        // this.config = props.config;

        // this.canvasRef = React.createRef();

        let self = this;

        // this.setCanvasRef = element => {
        //     // console.log('setCanvas ref', element);
        //     self.canvasRef = element;
        //     this.draw();
        //     // if (self.props.registerElement) {
        //     //     self.props.registerElement(self.props.id, element);
        //     // }
        // }

        // this.draw_throttled = function () {
        //     requestAnimationFrame(() => self.draw());
        // }

        // this.draw();
        // this.draw_throttled();
        this.getSrc = this.getSrc.bind(this);
    }

    getSrc() {
        if (typeof this.props.src == 'string') {
            return this.props.src;
        } else if (this.props.src.length) {
            return  this.props.src[this.props.zoomIndex]; //getIndexForZoom(this.props.src, this.props.mix, this.props.z)];
        }
    }


    // componentDidUpdate(prevProps) {
    //     if (prevProps.width != this.props.width ||
    //         prevProps.height != this.props.height ) {
    //             this.draw();//draw_throttled();
    //         }
    // }

    shouldComponentUpdate(nextProps) {
        if (this.width != nextProps.width
            ||
            this.height != nextProps.height
        ) {
                return true;
            }

        return true;
        // return true;

        if (this.props.itemsSelected !== nextProps.itemsSelected) {
            return true;
        }

        for (var i in nextProps) {
            if (i == 'fg' || i=='bg') {
                const child = nextProps[i];
                const oldChild = this.props[i];
                for (var j in child) {
                    // console.log(child, j, oldChild, i);
                    if (!oldChild[j] || child[j].key !== oldChild[j].key) {
                        return true;
                    }
                }
            } else if (nextProps[i] !== this.props[i]) {
                if (typeof nextProps[i] == 'object') {
                    if (!equal(nextProps[i], this.props[i]) ) {
                        return true;
                    }
                } else {
                    return true;
                }
            }
        }

        return false;
    }

    // draw() {
    //     console.log('draw canvas');
    //     if (true)
    //     {
    //         return;
    //     }
            
    //     if (!this.canvasRef) {
    //         return;
    //     }

    // }

    render() {
        // console.log('render', this.props.id, new Date().getMilliseconds());

        // console.log(JSON.stringify(process.env, 2));

        //const transform = 'translate('+ (this.props.x) +'px, '+ (this.props.y) +'px)';
        // const transform = this.props.transform
        // console.log(transform);
        
        let src = this.getSrc();
        let zoomIndex = this.props.zoomIndex;// getIndexForZoom(this.props.src, this.props.mix, this.props.z);
//        -(this.props.nativeWidth/2)
        let transform;
        
        if (zoomIndex == 0) {
            transform = `matrix(${1}, 0, 0, ${1}, ${this.props.tx}, ${this.props.ty})`;
        } else {
            transform = `matrix(${this.props.width/this.props.nativeWidth}, 0, 0, ${this.props.height/this.props.nativeHeight}, ${this.props.tx}, ${this.props.ty})`;
        }

        let icon_w = clamp( Math.min(this.props.width, this.props.height), 8, 32);
        let icon_h = icon_w;
        // const contentTransform = '';//`matrix(1, 0, 0, 1, 0, 0)`

        // console.log('**', this.props.id, 'fg', this.props.fg, 'bg', this.props.bg)

        return <>
        <div
            key={"container-"+this.props.id}
            style={{
                position: 'absolute',
                left: this.props.tx + 'px',
                top: this.props.ty + 'px',
                width: (this.props.width) + 'px',
                height: (this.props.height) + 'px'
            }}
        >
            { this.props.fg }
        </div>
        <div
            className={this.props.dragging ? 'CanvasExample grabbing draggable resizable' : 'CanvasExample draggable resizable' }
            style={{
                //display: this.props.hidden && !this.props.selected ? 'none' : 'initial',
                visibility: this.props.hidden && !this.props.selected ? 'hidden' : 'visible',
                // transform: this.props.hidden? 'none' : transform,

                position: 'absolute',
                // left: this.props.tx + 'px',
                // top: this.props.ty + 'px',

                transform: transform,
                transformOrigin: '0% 0%',
                // overflow: 'visible',

                // width: (this.props.width) + 'px',
                // height: (this.props.height) + 'px',

                // background: this.props.background

                pointerEvents: 'all'
            }}
            id={this.props.id}
        >

            { src ? 

            <img
                src={`${process.env.PUBLIC_URL}/${(zoomIndex == 0) ? this.props.src[1] : src}`} 
                key="scalingImg"
                style={{
                    pointerEvents: 'none',
                    
                    // zIndex: -1
                    visibility: (zoomIndex !== -1 && this.props.z < 0.1) ? 'hidden' : 'initial',
                    // transform: 'scale(100%, 100%)'
                    // width: '100%',
                    // height: '100%'
                }}
            /> : null }
        </div>

        {  
            src && (zoomIndex == 0 || zoomIndex == 1) ? 

        <img
            src={`${process.env.PUBLIC_URL}/${this.props.src[0]}`} 
            key="constSizeImg"
            style={{
                pointerEvents: 'none',
                position: 'absolute',
                position: 'absolute',
                left: this.props.tx + (this.props.width-icon_w)/2 + 'px',
                top: this.props.ty + (this.props.height-icon_h)/2 + 'px',
                width: icon_w,
                height: icon_h,
            }}
        /> : null }
        
        { this.props.bg }
        </>;
    }
}



const mapStateToProps = (state, ownProps) => {
    let background;
    let fg_color;

    switch (state.theme) {
        case 'sb-show-main theme-dark':
            background = '#000000';
            fg_color = '#FFFFFF';
            break;
        case 'sb-show-main theme-light':
            background = '#FFFFFF';
            fg_color = '#000000';
            break;
        case 'sb-show-main theme-cool':
            background = '#333540';
            fg_color = '#535560';
            break;
        case 'sb-show-main theme-warm':
            background = '#403335';
            fg_color = '#605355';
            break;
        default:
            background = ownProps.background;
            fg_color = ownProps.fg_color;
    }

    const z = state.camera.zoom;
    const panX = state.camera.pan.x;
    const panY = state.camera.pan.y;
    const cam_width = state.camera.size.width;
    const cam_height = state.camera.size.height;

    let scale = ownProps.width/ownProps.nativeWidth;
    let zoomIndex = getIndexForZoom(ownProps.src, ownProps.mix, z*scale);
    
    let tx;
    let ty;
    
    // 
    if (zoomIndex == 0) {
        tx = (ownProps.x + panX) * z + cam_width/2 - (ownProps.nativeWidth/2) + parseInt((ownProps.width) * z)/2
        ty = (ownProps.y + panY) * z + cam_height/2 - (ownProps.nativeHeight/2) + parseInt((ownProps.height) * z)/2
    } else {
        tx = (ownProps.x + panX) * z + cam_width/2
        ty = (ownProps.y + panY) * z + cam_height/2
    }

    return Object.assign(
        {}, 
        {
            background,
            fg_color
        },
        {
            itemsSelected: state.content.selection.length,
            selected: ownProps.selected,
            // x: parseInt((ownProps.x + state.camera.pan.x) * state.camera.zoom + state.camera.size.width/2),
            // y: parseInt((ownProps.y + state.camera.pan.y) * state.camera.zoom  + state.camera.size.height/2),
            z,
            width: parseInt((ownProps.width) * z),
            height: parseInt((ownProps.height) * z),

            tx,//: (ownProps.x + panX) * z + cam_width/2,
            ty,//: (ownProps.y + panY) * z + cam_height/2,


            // cam_width, 
            // cam_height, 
            panX, 
            panY,

            zoomIndex

            // zoom: state.camera.zoom,
        }
    );
}

CanvasExample.displayName = "CanvasExampleComponent";

const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(CanvasExample);
connectedComponent.displayName = "CanvasExample";


CanvasExample.propTypes = {
    /**
     * Background color
     */
    background: PropTypes.string,

    /**
     * Foreground color
     */
    fg_color: PropTypes.string,

    /**
     * Lock number of rows (ignore Redux store)
     */
    rows: PropTypes.number,

    /**
     * Lock number of columns (ignore Redux store)
     */
    columns: PropTypes.number,
    dragging: PropTypes.bool,
};

export default connectedComponent;
export { CanvasExample as CanvasExampleComponent };